import { render, staticRenderFns } from "./wlmz-record-list-dialog.vue?vue&type=template&id=78207a61&scoped=true&"
import script from "./wlmz-record-list-dialog.vue?vue&type=script&lang=js&"
export * from "./wlmz-record-list-dialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78207a61",
  null
  
)

export default component.exports